import { Outlet, useLocation, useSearchParams } from 'react-router-dom'

import { LegalFooter } from '../page/LegalFooter.tsx'
import { langFromSearch } from '../page/documentLang.ts'
import { SiteNotice } from './SiteNotice.tsx'

/**
 * The route shell. It carries no box of its own: `#root { display: contents }`
 * and this `Outlet` together mean the header, `.wrap` and the sticky summary
 * are laid out exactly as they were in a file where they were `<body>`'s own
 * children — which is what porting vB6's stylesheet unchanged requires.
 *
 * The test-system notice goes on every customer route but the index, whose
 * own banner (`page/shell.tsx`) already says it from the menu it has loaded.
 *
 * Legal pages brief (13 October 2026), item 3: the legal footer goes on every
 * customer route here — the return page, the mock payment page, the survey —
 * in the language the route takes from `?lang=`. The index draws its own,
 * because its language is in its state; `/staff/emails` is staff's and gets
 * none.
 */
export function Layout() {
  const { pathname } = useLocation()
  const [search] = useSearchParams()
  const customer = pathname !== '/' && !pathname.startsWith('/staff')
  return (
    <>
      {pathname === '/' ? null : <SiteNotice />}
      <Outlet />
      {customer ? <LegalFooter lang={langFromSearch(search)} /> : null}
    </>
  )
}
